type DateLike = string | Date;

export function GetTimeDifference(date1: DateLike, date2: DateLike): string {
  if (!date1 || !date2) {
    return '';
  }

  const date1Ms = date1 instanceof Date ? date1.getTime() : Date.parse(date1);
  const date2Ms = date2 instanceof Date ? date2.getTime() : Date.parse(date2);

  if (Number.isNaN(date1Ms) || Number.isNaN(date2Ms)) {
    return '';
  }

  const diffMs = date2Ms - date1Ms;

  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

  if (hours === 0 && minutes === 0) {
    return `${seconds} seconds`;
  } else if (hours === 0) {
    return `${minutes} minutes ${seconds} seconds`;
  } else {
    return `${hours} hours ${minutes} minutes ${seconds} seconds`;
  }
}
